<template>
  <div>
    <b-table
      id="gift-card-logs"
      ref="table"
      class="bg-white"
      bordered
      small
      responsive
      :fields="fields"
      :items="logs"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #cell(created_at)="data">
        <small :title="data.item.id">{{ moment(data.value).format('LLL') }}</small>
      </template>
      <template #cell(meta.recipient)="data">
        <div v-if="data.value">
          {{ data.value.name }}
          <small class="d-block">{{ data.value.email }}</small>
          <small v-if="data.value.mobile" class="d-block">{{ data.value.mobile }}</small>
        </div>
      </template>
      <template #cell(operation)="data">
        {{ trans(data.value) }}
        <small v-if="!!data.item.invoice_no" class="d-block">
          <b-link target="_blank" :href="getInvoiceUrl(data.item)">
            {{ trans('invoice') }} #{{ data.item.invoice_no }}
            <small><i class="fa fa-fw fa-external-link-alt"></i></small>
          </b-link>
        </small>
      </template>
      <template #cell(amount)="data">
        <span :class="data.item.operation == 'initiate_recharge_gift_card' ? 'text-muted' : ''" :title="data.item.operation == 'initiate_recharge_gift_card' ? trans('recharge_gift_card_after_paid') : null">
          {{ data.value }}<span v-if="data.item.operation == 'initiate_recharge_gift_card'">*</span>
        </span>
      </template>
      <template #cell(balance)="data">
        <strong>
          {{ data.value }}
        </strong>
      </template>
      <template #cell(meta.admin)="data">
        <div v-if="data.value">
          {{ data.value.name }}
        </div>
      </template>
    </b-table>
    <b-pagination
      :per-page="perPage"
      :total-rows="totalRows"
      v-model="currentPage"
      aria-controls="gift-card-logs"
      align="center"
    ></b-pagination>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      gift_card: Object,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        fields: _.compact([
          {key: 'created_at', label: trans('date')},
          {key: 'meta.admin', label: trans('administrator')},
          {key: 'meta.recipient', label: trans('client')},
          {key: 'operation', label: trans('operation')},
          {
            key: 'amount',
            label: trans('amount'),
            formatter(value, key, item) {
              return _.isNumeric(value) ? _.currency(value) : null
            },
          },
          {
            key: 'balance',
            label: trans('balance'),
            formatter(value, key, item) {
              return _.currency(value)
            },
          },
        ]),
        perPage: 5,
        currentPage: 1,
      }
    },
    computed: {
      logs() {
        return this.gift_card ? this.gift_card.logs : []
      },
      totalRows() {
        return this.logs.length
      },
    },
    methods: {
      getInvoiceUrl(item) {
        if (window.location.href.indexOf('/org/') > 0)
          return `/org/${this.organization.id}/client/invoice/${item.invoice_no}`
        return `/organization/${this.organization.id}/invoice/?invoice_no=${item.invoice_no}`
      },
    },
    mounted() {
      window.gitfCardModal = this
    },
  }
</script>